<p-dropdown (onChange)="managerChange($event.value)" [options]="users" [(ngModel)]="manager"
	placeholder="Project Manager" optionLabel="name"></p-dropdown>

<!-- <p-autoComplete [(ngModel)]="manager" [suggestions]="users" [dropdown]="true" field="name">
	<ng-template let-manager pTemplate="item">
		<div class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5">
			<div style="font-size:18px;float:right;margin:10px 10px 0 0">{{manager.name}}</div>
		</div>
	</ng-template>
</p-autoComplete> -->